module.exports = __webpack_public_path__ + "static/image 7-69d8ea35e832ccd5274bf8764401a542.png";